import axios from "axios";

const { REACT_APP_ENVIRONMENT } = process.env;

let address;
if (REACT_APP_ENVIRONMENT === "LIVE") {
  address = "https://livedashboard.yomento.net";
}
if (REACT_APP_ENVIRONMENT === "DEVELOPMENT") {
  address = "http://testdashboard.yomento.net";
}

export const getDashboardStats = ({ id, secret }) => {
  const headers = {
    "client-id": id,
    "client-secret": secret,
  };

  const data = { programme_ids: [100104, 100105, 100106, 100107, 100109, 100110] };

  return axios
    .post(`${address}/api/v1/dashboardStats`, data, headers)
    .then((res) => res)
    .catch((err) => {
      console.log({ err });
    });
};

export const postBulkEdit = (payload) =>
  axios
    .post(`${address}/api/v1/changeMemberStatus`, payload)
    .then((res) => res)
    .catch((err) => console.error(err));

export const postMoveGroups = (payload) =>
  axios
    .post(`${address}/api/v1/move2AnotherGroup`, payload)
    .then((res) => res)
    .catch((err) => console.error(err));

export const getAllMembers = (payload) =>
  axios
    .post(`${address}/api/v1/showMembers`, {
      programme_ids: payload,
    })
    .then((res) => res.data)
    .catch((err) => {
      console.error(err);
    });
